import React from 'react'

const Reloadicon = () => {
  return (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.32725 5.48484C4.03254 2.8031 7.21037 1 10.8491 1C16.2885 1 20.6981 5.02944 20.6981 10C20.6981 14.9706 16.2885 19 10.8491 19C5.40957 19 1 14.9706 1 10" stroke="#000" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.15564 5.5H2.23111V1" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default Reloadicon